<template>
  <span class="member-name">
    <span class="member-name__text">{{ displayName }}</span>
    <CrownFilled v-if="isMember" class="member-name__crown" title="会员" />
    <span v-if="isMember" class="member-name__svip">SVIP</span>
  </span>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { CrownFilled } from '@ant-design/icons-vue'

const props = withDefaults(defineProps<{
  name?: string | null
  isMember?: boolean
  fallback?: string
}>(), {
  name: '',
  isMember: false,
  fallback: '用户'
})

const displayName = computed(() => {
  const value = String(props.name || '').trim()
  return value || props.fallback
})
</script>

<style scoped lang="less">
.member-name {
  display: inline-flex;
  align-items: center;
  min-width: 0;
  gap: 4px;
  vertical-align: middle;
}

.member-name__text {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.member-name__crown {
  flex: 0 0 auto;
  color: #f7b731;
  font-size: 0.95em;
  filter: drop-shadow(0 1px 2px rgba(247, 183, 49, 0.35));
}

.member-name__svip {
  flex: 0 0 auto;
  display: inline-flex;
  align-items: center;
  height: 16px;
  padding: 0 5px;
  border-radius: 999px;
  background: linear-gradient(135deg, #06b6d4, #14b8a6);
  color: #ffffff;
  font-size: 10px;
  font-weight: 900;
  line-height: 1;
  letter-spacing: 0;
  box-shadow: 0 3px 8px rgba(20, 184, 166, 0.24);
}
</style>
